import { debounce } from 'lodash';
import React from 'react';
import { useDispatch } from 'react-redux';
// import { useState } from 'react';
import { FormDashboardTextarea, PopupBasic, SaveButton } from '../../../components';
import { updateForm } from '../../../features/event-form/slice';
import { useInternationalization } from '../../../features/i18n';

const labelTitle = {
  en: 'Reschedule',
  id: "Penjadwalan Ulang"
}

const labelPlaceholder = {
  en: 'Write message',
  id: "Tulis pesan"
}

const ReschedulePopup = ({showPopup, setShowPopup, onSubmit}) => {
  const dispatch = useDispatch()
  // const [ note, setNote ] = useState('')
  const { translate, language } = useInternationalization()

  const setNote = debounce((e) =>{
    dispatch(updateForm({
      key: 'note',
      value: e
    }))
  }, 100)

  return <>
    {
      showPopup &&
      <PopupBasic title={labelTitle[language.name]} onClose={() => setShowPopup(false)}>
        <p className="text-sm mb-6 text-gray-444">
          {translate('EVENT', 'reschedule_message')}
        </p>
        <FormDashboardTextarea
          className="w-full mb-8"
          placeholder={labelPlaceholder[language.name]}
          onChange={e => setNote(e.target.value)}
        />
        <div className="flex flex-wrap items-center">
          <div className="w-full md:w-auto lg:w-auto">
            <SaveButton mobileClassname="mb-5" onClick={onSubmit}/>
          </div>
          <div className="w-full md:w-auto lg:w-auto text-center lg:text-left">
            <p className="cursor-pointer px-8 text-gray-444 underline text-xs lg:text-sm" onClick={() => setShowPopup(false)}>
              {translate('GENERAL', 'cancel')}
            </p>
          </div>
        </div>
      </PopupBasic>
    }
  </>
}

export default ReschedulePopup
